import { openBlock as t, createElementBlock as a, createStaticVNode as l } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#000" d="M5.858 34.142c-7.81-7.81-7.81-20.474 0-28.284L17.39 20 5.858 34.142Z"></path><path fill="#FFDA44" d="M17.391 20 2.653 10.04a20.03 20.03 0 0 0-1.207 2.482L8.908 20l-7.461 7.48c.346.858.748 1.686 1.205 2.48L17.392 20Z"></path><path fill="#6DA544" d="M39.83 17.391H17.39L5.859 5.858a20.08 20.08 0 0 0-3.205 4.182l9.94 9.96-9.941 9.959a20.076 20.076 0 0 0 3.206 4.183L17.39 22.61h22.44a20.208 20.208 0 0 0 0-5.218Z"></path><path fill="#0052B4" d="M7.823 35.865A19.912 19.912 0 0 0 20 40c9.24 0 17.016-6.267 19.31-14.783H18.472L7.823 35.865Z"></path><path fill="#D80027" d="M39.31 14.783C37.017 6.267 29.24 0 20 0A19.912 19.912 0 0 0 7.823 4.135l10.648 10.648h20.84Z"></path>', 6), o = [
  h
];
function c(p, i) {
  return t(), a("svg", e, [...o]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
